import Component from '../core/Component'
import { enableScroll, disableScroll } from '../services/Scroll'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'

export const STATES = {
	VISIBLE: 'is-visible',
	ACTIVE: 'is-active',
	SCROLLABLE: 'is-scrollable',
}

export default class PopupNav extends Component {
	constructor(element) {
		super(element)

		this.ref = {
			content: null,
			bg: null,
			inner: null,
		}

		this.timer = null
	}

	prepare() {
		this.element.addEventListener('click', this.handleClick)
		this.ref.bg.addEventListener('transitionend', (event) => {
			if (this.ref.bg === event.target && !this.is(STATES.ACTIVE)) {
				this.element.classList.remove(STATES.VISIBLE)
			}
		})
		EventBus.on(EVENTS.POPUPNAV_TOGGLE, this.handlePopupNavToggle)
		EventBus.on(EVENTS.SWUP_CLICK_LINK, this.handleSwupClickLink)
	}

	destroy() {
		this.close()

		EventBus.off(EVENTS.POPUPNAV_TOGGLE, this.handlePopupNavToggle)
		EventBus.off(EVENTS.SWUP_CLICK_LINK, this.handleSwupClickLink)
	}

	handleDocumentClick = (event) => {
		if (!this.element.contains(event.target)) {
			this.close()
		}
	}

	handleSwupClickLink = () => {
		this.close()
	}

	handlePopupNavToggle = () => {
		this.toggle()
	}

	handleClick = (event) => {
		if (event.target.closest('a') || this.element === event.target) {
			this.close()
		}
	}

	handleKeydown = (event) => {
		if (event.key === 'Escape') {
			this.close()
		}
	}

	clear() {

	}

	toggle() {
		if (this.is(STATES.ACTIVE)) {
			this.close()
		} else {
			this.open()
		}
	}

	close() {
		if (!this.is(STATES.ACTIVE)) {
			return
		}
		this.element.classList.remove(STATES.ACTIVE)
		document.removeEventListener('keydown', this.handleKeydown)
		enableScroll()
		EventBus.emit(EVENTS.POPUPNAV_CLOSED)
		document.body.classList.remove('u-popupnav-open')
		document.removeEventListener('click', this.handleDocumentClick)
		this.clear()
		clearTimeout(this.timer)
		this.element.classList.remove(STATES.SCROLLABLE)
	}

	open() {
		this.clear()
		disableScroll()
		this.element.classList.add(STATES.VISIBLE)
		this.element.offsetWidth
		this.element.classList.add(STATES.ACTIVE)
		this.ref.bg.style.height = `${this.ref.inner.offsetHeight}px`
		document.addEventListener('keydown', this.handleKeydown)
		EventBus.emit(EVENTS.POPUPNAV_OPENED)
		document.body.classList.add('u-popupnav-open')
		setTimeout(() => {
			document.addEventListener('click', this.handleDocumentClick)
		}, 0);

		this.timer = setTimeout(() => {
			this.element.classList.add(STATES.SCROLLABLE)
		},1000)
	}
}
